import React, { useState } from 'react';
// Modal
import BookingFormModal from '../../../layouts/Modals/BookingFormModal';

const BookingsCreate = () => {
  const [ show, setShow ] = useState(false);
  return (
    <>
      <div className="form-group text-right">
        <button
          className="btn btn-primary btn-sm"
          type="button"
          onClick={() => setShow(true)}
        >Create</button>
      </div>
      {/* Modal */}
      {show &&
        <BookingFormModal
          show={show}
          onHide={() => setShow(false)}
        />
      }
    </>
  )
}

export default BookingsCreate;
